export const isNotNull = <T>(item: T): item is Exclude<T, null | undefined> => item !== null && item !== undefined

export const nonNull = <T>(items: T[]): Exclude<T, null | undefined>[] => {
  return items.filter(isNotNull)
}